import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { services, safeStatement } from "@/data/siteConfig";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ContactCTA } from "@/components/home/ContactCTA";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export default function Services() {
  return (
    <>
      <Seo
        title="Safe & Vault Services"
        description="Safe and vault services from Velasco Lock and Safe — safe opening, safe moving, heavy safe moving, removal, disposal, installation, lock and keypad repair and retrofits in Norwalk and Southern California."
        path="/services"
      />
      <PageHero
        overline="Safe & Vault Services"
        title="Safe & vault work, done right"
        description="Safe opening, moving, removal, disposal, installation, lock repair, keypad replacement and retrofits — Velasco Lock and Safe specializes in safe and vault work throughout Southern California."
      />

      <section className="bg-ink py-24 md:py-28">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8">
          <RevealGroup className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {services.map((s) => {
              const Icon = s.icon;
              return (
                <RevealItem key={s.slug}>
                  <div
                    data-testid={`service-detail-${s.slug}`}
                    className="group flex h-full flex-col border border-white/10 bg-ink-surface p-8 transition-colors duration-300 hover:border-gold/40"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-sm border border-white/10 bg-ink text-gold transition-colors duration-300 group-hover:border-gold/50">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-6 font-heading text-xl font-bold text-white">{s.title}</h3>
                    <p className="mt-3 flex-1 leading-relaxed text-steel">{s.body}</p>
                  </div>
                </RevealItem>
              );
            })}
          </RevealGroup>

          <div className="mt-16 flex flex-col items-start justify-between gap-6 overflow-hidden border border-gold/25 bg-gradient-to-br from-ink-surface to-ink p-8 md:flex-row md:items-center md:p-12">
            <div className="max-w-2xl">
              <div className="mb-3 flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-[0.2em] text-gold">
                <ShieldCheck className="h-4 w-4" /> Safe Specialists
              </div>
              <h3 className="font-heading text-2xl font-bold text-white sm:text-3xl">
                Difficult, heavy or high-security safe project?
              </h3>
              <p className="mt-3 leading-relaxed text-steel">{safeStatement}</p>
            </div>
            <Link
              to="/safe-services"
              data-testid="services-to-safe"
              className="group inline-flex h-14 shrink-0 items-center gap-2 rounded-sm bg-gold px-7 font-heading text-sm font-bold uppercase tracking-[0.08em] text-ink transition-transform duration-300 hover:scale-[1.02]"
            >
              Safe Services
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
